import { create } from 'zustand'
import { getOrganization } from './orgPanelApiCalls';
import Cookies from './AutoCookies';
import Countries from '../constants/countries';
import CookieKeys from '../constants/cookies';

//Implemented via Zustand - see documentation here:
// https://github.com/pmndrs/zustand


//Store
export const useStore = create(() => ({
    CurrentOrganizationId: 0,
    CurrentOrganization: {},
    NewLicenseCount: null,
    isLoading: true,
    Subscription: {},
    UserRoles: [],
    Configuration: {},
    CurrentUserAccountId: 0,
    TenantCollection: null,
    toast: null
}))


//Actions
const setToast = (data) => {
    useStore.setState((state) => ({ ...state, toast: data }));
}
export const toastToggleCallback = () => {
    setToast({
        display: false,
        message: ""
    });
};
export const makeToast = (message, type) => {
    setToast({
        display: true,
        message: message,
        type: type
    });
};
export const inc = () =>
    useStore.setState((state) => ({ count: state.count + 1 }));


export const setSubscription = (data) => {

    useStore.setState((state) => ({ ...state, Subscription: data }));

}
export const setUserRoles = (data) => {
    useStore.setState((state) => ({ ...state, UserRoles: data }));
}


export const setCurrentOrganizationId = (id) => useStore.setState((state) => ({ ...state, CurrentOrganizationId: id }))
export const setCurrentOrganization = (org) => useStore.setState((state) => ({ ...state, CurrentOrganization: org }))
export const setNewLicenseCount = (newLicenseCount) => useStore.setState((state) => ({ ...state, NewLicenseCount: newLicenseCount }))
export const setIsLoading = (bool) => useStore.setState((state) => ({ ...state, isLoading: bool }))
export const changeOrganizationAndLoad = (id) => {
    async function load() {
        setIsLoading(true);
        var response = await getOrganization(id);
        if (response.status === 401 || response.status === 403 || response.data == null || response.data === -1) {
            //kaboom
            setIsLoading(false);
            return;
        }
        else {
            setCurrentOrganization(response);
            setCurrentOrganizationId(id);
            setIsLoading(false);
        }
    } load();
}
 //Env configuration info
export const setConfiguration = (config) => useStore.setState((state) => ({ ...state, Configuration: config }));

//Teanat & User Account info

export const setTenantCollection = (data) => {
    useStore.setState((state) => ({ ...state, TenantCollection: data }))
    Cookies.set(CookieKeys.TenantCollection, JSON.stringify(data), { expires: 7 });
};
export const unsetTenantCollectionAndUserAccount = () => {
    setTenantCollection(null);
    Cookies.remove(CookieKeys.TenantCollection);
    Cookies.remove(CookieKeys.UserAccountId);
}
export const setTenantCollectionAndUserAccount = (tenantData) => {
    const { assignedTenants } = tenantData;


    if (assignedTenants?.length > 0) {
        let selectedTenantFromCookie = null;
        try {
            const raw = Cookies.get(CookieKeys.TenantCollection);
            if (raw) {
                const parsed = JSON.parse(raw);
                const selectedTenant = Object.values(parsed).find(t => t.selected);
                // Validate that the selected tenant from cookie actually exists in the current user's assigned tenants
                if (selectedTenant && assignedTenants.some(t => t.accountId === selectedTenant.accountId)) {
                    selectedTenantFromCookie = selectedTenant;
                } else if (selectedTenant) {
                    console.warn('Selected tenant from cookie does not belong to current user. Clearing stale cookie data.');
                    Cookies.remove(CookieKeys.TenantCollection);
                }
            }
        } catch {
            console.error('Could not parse cookie value');
        }
        // Find the oldest tenant based on the last selected one or createdDateTime
        const oldestTenant = selectedTenantFromCookie ?? assignedTenants.reduce((oldest, current) => {
            return new Date(current.createdDateTime) < new Date(oldest.createdDateTime)
                ? current
                : oldest;
        }, assignedTenants[0]);

        const tenants = {};
        assignedTenants.forEach((item) => {
            tenants[item.accountId] = {
                accountId: item.accountId,
                name: item.name,
                createdDateTime: item.createdDateTime,
                selected: item.accountId === oldestTenant.accountId,
                country: item.country ?? Countries.USA
            };
        });

        setTenantCollection(tenants);
    }
};
export const setSelectedTenant = (accountId) => {
    useStore.setState((state) => {
        const updated = { ...state.TenantCollection };

        Object.keys(updated).forEach((key) => {
            updated[key] = {
                ...updated[key],
                selected: updated[key].accountId === accountId
            };
        });

        Cookies.set(CookieKeys.TenantCollection, JSON.stringify(updated), { expires: 7 });

        return { ...state, TenantCollection: updated };
    });
};


export const getSelectedTenant = () => {
    const state = useStore.getState();
    if (!state?.TenantCollection) return null;

    return Object.values(state.TenantCollection).find(t => t.selected) || null;
};

export const getTenantCountry = () => {
    return getSelectedTenant()?.country;
}

export const updateAccountNameInTenantCollection = (id, updatedName) => {
    useStore.setState((state) => {
        const updated = { ...state.TenantCollection };

        if (updated[id]) {
            updated[id] = {
                ...updated[id],
                name: updatedName
            };
            Cookies.set(CookieKeys.TenantCollection, JSON.stringify(updated), { expires: 7 });
            return { ...state, TenantCollection: updated };
        }

        return { ...state }; // No change if id not found
    });
};
